import styled from '@emotion/styled'
import React from 'react'
import { useMediaQuery } from 'react-responsive'

const H1 = styled.h1<{
  isBold: boolean
  color?: string
  isMobile: boolean
  whiteSpace: boolean
}>`
  color: ${(props) => (props.color ? props.color : '#F9F9FB')};
  font-size: ${(props) => (props.isMobile ? '36px' : '72px')};
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  line-height: ${(props) => (props.isMobile ? '160%' : '125%')};
  white-space: pre;
  @media screen and (min-width: 1100px) {
    word-break: normal;
    white-space: nowrap;
  }
`

const HeaderText = ({
  text = '',
  isBold = true,
  color = '',
  whiteSpace = true,
}: {
  text: string
  isBold?: boolean
  color?: string
  whiteSpace?: boolean
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:1099px)' })
  return (
    <H1
      isBold={isBold}
      color={color}
      isMobile={isMobile}
      whiteSpace={whiteSpace}
    >
      {text}
    </H1>
  )
}

export default HeaderText
